var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 27,
    viewBox: "0 0 32 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5611 0.669312V11.7477H0.0810547V26.1496H19.1213V21.7182H31.4414V7.31634H23.6013V0.669312H4.5611ZM6.80113 2.88499H21.3613V7.31634H11.2812V11.7477H6.80113V2.88499ZM13.5212 9.53202H29.2014V19.5026H19.1213V11.7477H13.5212V9.53202ZM23.6013 11.7477V13.9634H26.9613V11.7477H23.6013ZM2.32108 13.9634H4.5611H12.4012H16.8812V15.1967L10.1174 19.3554C9.80493 19.5482 9.39851 19.5493 9.0849 19.3554L2.32108 15.1989V13.9634ZM16.8812 17.8062V23.9339H2.32108V17.8083L7.90145 21.2379C8.42562 21.5603 9.01427 21.7226 9.60116 21.7226C10.188 21.7226 10.7756 21.5603 11.2987 21.2357L16.8812 17.8062Z",
    fill: "#445A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSvg);
export default __webpack_public_path__ + "static/media/mail_svg.49394ec5319423d0be6de8b96b540182.svg";
export { ForwardRef as ReactComponent };